import { useQuery } from '@tanstack/react-query';
import { listApprovers } from '@/lib/users-api';

/**
 * Colleagues who could approve a campaign.
 *
 * `staleTime` is generous — five minutes — because the directory changes when somebody signs in for the
 * first time, which is rare, and the cost of a stale list is that a colleague who joined this morning is
 * missing until the next refetch. That is a much smaller problem than refetching a directory on every
 * mount of a panel that appears on every campaign screen.
 */
export function useApprovers(enabled: boolean) {
  return useQuery({
    queryKey: ['approvers'] as const,
    queryFn: listApprovers,
    staleTime: 5 * 60 * 1000,
    enabled,
  });
}
